/* el-sci-day — the contact-time calculator.

   IT ASKS RATHER THAN ASSUMES. This takes ONE number from the reader - how many times a day
   they drink or eat something that stains - and computes from that. No assumed schedule, no
   invented curve, no claim about when anything happens.

   EVERYTHING IS ARITHMETIC, and every constant is declared here:
     brushMin   2 sessions x 1.5 min           = 3 min/day
     chewMin    2 servings x 20 min            = 40 min/day, but only as much as brushing leaves
     stainMin   events x MIN_PER_EVENT (12)    - a stated assumption, printed under the panel
   THE THREE ROWS SUM TO THE DAY: brushing + chewing + the hole = stainMin, always. Chew minutes
   are capped at what brushing leaves, so at 3 events (36 min) the chews cover 33 and the hole
   is 0; at 8 events (96 min) they cover 40 and the hole is 53. Nothing ever reads over 100%.

   No JS: the markup ships a valid default state from Liquid, so the section is never empty. */
(function () {
  var root = document.querySelector('[data-el-sci-day]');
  if (!root) return;

  var MIN_PER_EVENT = parseFloat(root.dataset.elMinPerEvent) || 12;
  var BRUSH_MIN = parseFloat(root.dataset.elBrushMin) || 3;
  var CHEW_MIN = parseFloat(root.dataset.elChewMin) || 40;

  // translated templates printed by the section (Liquid is the only place a translation exists)
  var T_MIN = root.dataset.elTMin || '__N__ min';
  var T_SPARE = root.dataset.elTSpare || '__S__ minutes of stain a day. Brushing covers __B__. 2 chews cover the other __C__, with __R__ minutes to spare.';
  var T_HOLE = root.dataset.elTHole || '__S__ minutes of stain a day. Brushing covers __B__. 2 chews cover __C__. __H__ minutes with nothing working.';
  function fill(t, map) { Object.keys(map).forEach(function (k) { t = t.split(k).join(String(map[k])); }); return t; }

  var input = root.querySelector('[data-el-day-input]');
  var out = {
    events: root.querySelector('[data-el-out-events]'),
    stain: root.querySelector('[data-el-out-stain]'),
    brushVal: root.querySelector('[data-el-out-brushval]'),
    chewVal: root.querySelector('[data-el-out-chewval]'),
    holeVal: root.querySelector('[data-el-out-holeval]'),
    brushPct: root.querySelector('[data-el-out-brushpct]'),
    chewPct: root.querySelector('[data-el-out-chewpct]'),
    holePct: root.querySelector('[data-el-out-holepct]'),
    verdict: root.querySelector('[data-el-out-verdict]'),
    brushBar: root.querySelector('[data-el-bar-brush]'),
    chewBar: root.querySelector('[data-el-bar-chew]'),
    holeBar: root.querySelector('[data-el-bar-hole]')
  };
  if (!input) return;

  function paint() {
    var events = Math.max(1, Math.min(8, parseInt(input.value, 10) || 1));
    var stain = events * MIN_PER_EVENT;
    var room = stain - BRUSH_MIN;
    var chewUsed = Math.min(CHEW_MIN, room);
    var hole = stain - BRUSH_MIN - chewUsed;
    var pct = function (m) { return ((m / stain) * 100).toFixed(1) + '%'; };

    if (out.events) out.events.textContent = events;
    if (out.stain) out.stain.textContent = stain;
    if (out.brushVal) out.brushVal.textContent = fill(T_MIN, { __N__: BRUSH_MIN });
    if (out.chewVal) out.chewVal.textContent = fill(T_MIN, { __N__: chewUsed });
    // Displayed shares sum to 100 by construction: round two, the hole takes the remainder.
    // Independently rounded they printed 101 / 99 / 101 at 2, 4 and 7 events.
    var brushShare = Math.round((BRUSH_MIN / stain) * 100);
    var chewShare, holeShare;
    if (hole === 0) { holeShare = 0; chewShare = 100 - brushShare; }           // 0 min cannot own the remainder
    else { chewShare = Math.round((chewUsed / stain) * 100); holeShare = 100 - brushShare - chewShare; }
    if (out.brushPct) out.brushPct.textContent = brushShare + '%';
    if (out.chewPct) out.chewPct.textContent = chewShare + '%';
    if (out.holePct) out.holePct.textContent = holeShare + '%';
    if (out.holeVal) out.holeVal.textContent = fill(T_MIN, { __N__: hole });
    if (out.brushBar) out.brushBar.style.setProperty('--el-day-w', pct(BRUSH_MIN));
    if (out.chewBar) out.chewBar.style.setProperty('--el-day-w', pct(chewUsed));
    if (out.holeBar) out.holeBar.style.setProperty('--el-day-w', pct(hole));
    if (out.verdict) {
      out.verdict.textContent = hole === 0
        ? fill(T_SPARE, { __S__: stain, __B__: BRUSH_MIN, __C__: chewUsed, __R__: CHEW_MIN - chewUsed })
        : fill(T_HOLE, { __S__: stain, __B__: BRUSH_MIN, __C__: chewUsed, __H__: hole });
    }
  }

  input.addEventListener('input', paint);
  input.addEventListener('change', paint);
  paint();
})();
